var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValorantGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.349 15.62V6.153c0-.146-.183-.206-.28-.097L17.726 18.979c-.085.097-.012.255.122.255h7.471a.64.64 0 00.511-.255l2.36-2.945a.624.624 0 00.159-.414zm-24.19.426l7.763 9.71a.652.652 0 00.523.244h7.471c.134 0 .207-.146.122-.243L4.28 6.068c-.097-.11-.28-.048-.28.098v9.466c.012.147.06.293.158.414z",
    fill: "#CDDCFE"
  })));
}
export default __webpack_public_path__ + "static/_/_/shared/assets/games/valorant-grey.svg";
export { SvgValorantGrey as ReactComponent };